<!-- /news right-hand column: "Year" (not "Archive", the primary navigation item). Each year
     links to its page, /news/2026, /news/2025…; the one being shown (also on its item pages)
     is green. -->

<template>
  <aside class="archive">
    <h4>Year</h4>
    <ul>
      <li v-for="{year} in archive" :key="year">
        <router-link :to="`/news/${year}`" :class="{isSelected: year === route.params.year}">
          {{ year }}
        </router-link>
      </li>
    </ul>
  </aside>
</template>

<script setup>
import {onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import {fetchNewsArchive} from "@/composables/useNews";

const route = useRoute();
const archive = ref([]); // [{year, months}], newest first; only the years are used here

onMounted(async () => {
  archive.value = await fetchNewsArchive();
});
</script>

<style scoped>
ul,
li {
  list-style: none; /* no bullets (also on li: a global li style would otherwise win) */
  padding: 0;
  margin: 0;
}
li {
  margin-bottom: 0.25rem;
}
/* a label, not a link */
h4 {
  color: var(--text-color-less-subtle);
}
/* years in neutral text colour (white in the dark theme), not link blue; no underline until
   hover (as the row dates); the one shown in green */
a {
  color: var(--text-color);
  text-decoration: none;
}
a:hover {
  color: var(--text-color);
  text-decoration: underline;
}
a.isSelected,
a.isSelected:hover {
  color: var(--brand-color);
  font-weight: 700;
}
</style>
